<!--
  WB-7938 — shared by the order detail header and the side-by-side panel header.
  Fixed order: lifecycle state first, then the mode the record is locked into,
  then the two tags that point at something the user can act on.
-->
<span *ngIf="showStatus" class="order-tag order-tag--status" data-testid="order-status-badge" [ngStyle]="getStatusStyles()">
  {{ 'quotations_and_orders.QuotationStatus.' + status | translate }}
</span>

<!-- WB-7478: records that reached the ERP are read-only (computed front-end). -->
<span *ngIf="isReadOnly" class="order-tag order-tag--read-only">
  <ui-svg-icon svgIcon="lock" size="small"></ui-svg-icon>
  {{ 'quotations_and_orders.order_tags.read_only' | translate }}
</span>

<!--
  WB-7569: a splitting rule applies to this order. Clickable — it re-opens the
  split proposal, so dismissing that modal is never terminal.
-->
<button
  type="button"
  *ngIf="showSplit"
  class="order-tag order-tag--split"
  [class.order-tag--split-disabled]="splitBlocked"
  [attr.aria-disabled]="splitBlocked || null"
  (click)="onSplitClick()"
  [matTooltip]="(splitBlocked
    ? 'quotations_and_orders.order_tags.split_applies_blocked_tooltip'
    : 'quotations_and_orders.order_tags.split_applies_tooltip') | translate"
  matTooltipPosition="below">
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M16 3h5v5"/>
    <path d="M8 3H3v5"/>
    <path d="M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3"/>
    <path d="m15 9 6-6"/>
  </svg>
  {{ 'quotations_and_orders.order_tags.split_applies' | translate }}
</button>

<app-duplicate-badge
  *ngIf="showDuplicate"
  size="big"
  [duplicateInfo]="quotation!.duplicate_info!"
  (dismissed)="duplicateDismissed.emit()"
  (click)="$event.stopPropagation()">
</app-duplicate-badge>
